import React, { useState } from 'react';
import axios from 'axios';
import { useModal } from '../context/ModalContext';
import ImageUpload from './ImageUpload';
import '../styles/Modal.css';

const CreateOrganizationModal = ({ onClose, onSuccess, clients, apiPrefix }) => {
  const modal = useModal();
  const [organizationForm, setOrganizationForm] = useState({
    organization_name: '',
    owner_id: '',
    icon_url: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${apiPrefix}/create-organization`, organizationForm, { withCredentials: true });
      modal.success('Organization created successfully!');
      setOrganizationForm({ organization_name: '', owner_id: '', icon_url: '' });
      if (onSuccess) await onSuccess(response.data?.organization_id);
      onClose();
    } catch (error) {
      console.error('Error creating organization:', error);
      modal.error(error.response?.data?.error || 'Failed to create organization');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3 className="modal-title">Create Organization</h3>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close" />
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="org-name">Organization Name *</label>
            <input
              type="text"
              id="org-name"
              value={organizationForm.organization_name}
              onChange={(e) => setOrganizationForm({...organizationForm, organization_name: e.target.value})}
              placeholder="Enter organization name"
              required
              disabled={isSubmitting}
              autoComplete="off"
              data-1p-ignore="true"
              data-lpignore="true"
              data-bwignore="true"
              data-form-type="other"
            />
          </div>
          <div className="form-group">
            <ImageUpload
              value={organizationForm.icon_url}
              onChange={(s3_url) => setOrganizationForm({...organizationForm, icon_url: s3_url})}
              onClear={() => setOrganizationForm({...organizationForm, icon_url: ''})}
              label="Organization Icon"
              required={false}
              maxSizeMB={5}
              fileType="organization_icon"
            />
          </div>
          <div className="form-actions">
            <button type="button" className="button-main" onClick={onClose} disabled={isSubmitting}>
              Cancel
            </button>
            <button type="submit" className="button-main" disabled={isSubmitting}>
              {isSubmitting ? 'Creating...' : 'Create Organization'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateOrganizationModal;
